import React from "react";
import ErrorBoundary from "./Support/ErrorBoundary";
import Form from "./Form";
import Loader from "./Loader";
import Result from "./Result";
import {
    EVENT_FORM_SUBMITTED,
    EVENT_RESET,
    EVENT_ERROR,
    EVENT_RESULT_AVAILABLE,
    EVENT_DETAILS_BUTTON_CLICKED, EVENT_LEAD_CONFIRMED, EVENT_LEAD_MODAL_CLOSED
} from "./Support/Events";
import axios from "axios";
import {getUrlParam} from "./Support/Helper";
import LeadModal from "./LeadModal/LeadModal";

const VIEW_SCAN_FORM = 'scan-form';
const VIEW_SCAN_LOADER = 'scan-loader';
const VIEW_SCAN_RESULT = 'scan-result';

const initialState = {
    view: VIEW_SCAN_FORM,
    url: null,
    result: null,
    scan_id: null,
    check_result_interval: null,
    check_result_count: 0,
    show_lead_modal: false
}

export default class Main extends React.Component {

    constructor(props) {
        super(props);
        this.state = initialState;
        this.reset = this.reset.bind(this);
        this.onScanFormSubmit = this.onScanFormSubmit.bind(this);
        this.startScan = this.startScan.bind(this);
        this.startCheckResult = this.startCheckResult.bind(this);
        this.clearCheckResultInterval = this.clearCheckResultInterval.bind(this);
        this.checkResult = this.checkResult.bind(this);
        this.onResultAvailable = this.onResultAvailable.bind(this);
        this.onDetailsButtonClicked = this.onDetailsButtonClicked.bind(this);
        this.onLeadConfirmed = this.onLeadConfirmed.bind(this);
        this.onModalClosed = this.onModalClosed.bind(this);
        this.updateView = this.updateView.bind(this);
    }

    componentDidMount() {
        document.addEventListener(EVENT_RESET, this.reset);
        document.addEventListener(EVENT_FORM_SUBMITTED, this.onScanFormSubmit);
        document.addEventListener(EVENT_RESULT_AVAILABLE, this.onResultAvailable);
        document.addEventListener(EVENT_DETAILS_BUTTON_CLICKED, this.onDetailsButtonClicked);
        document.addEventListener(EVENT_LEAD_CONFIRMED, this.onLeadConfirmed);
        document.addEventListener(EVENT_LEAD_MODAL_CLOSED, this.onModalClosed);
        document.addEventListener(EVENT_ERROR, this.clearCheckResultInterval);
        window.addEventListener('popstate', this.updateView);

        let scan_id = new URLSearchParams(window.location.search).get('s') ?? new URLSearchParams(window.location.search).get('scan');

        if (scan_id) {
            document.dispatchEvent(new CustomEvent(EVENT_FORM_SUBMITTED, {
                detail: {
                    scan_id: scan_id
                }
            }));
        }

        let url = getUrlParam();

        if (url) {
            this.setState({
                url: url
            }, () => {
                let autostart = new URLSearchParams(window.location.search).get('autostart');

                if (parseInt(autostart) === 1) {
                    document.dispatchEvent(new CustomEvent(EVENT_FORM_SUBMITTED, {
                        detail: {
                            url: url
                        }
                    }));
                }
            });
        }
    }

    updateView(e) {
        if (e.state && e.state.view) {
            this.setState(e.state);
        }
    }

    updateBrowserUrl() {
        try {
            let newLocationUrl = new URL(window.location);

            // add hash param to URL
            let scan_id = this.state.scan_id;

            if (scan_id) {
                if (this.props.premium || new URLSearchParams(window.location.search).get('scan'))
                    newLocationUrl.searchParams.set('scan', scan_id);
                else
                    newLocationUrl.searchParams.set('s', scan_id);
            } else if (newLocationUrl.searchParams.has('s') || newLocationUrl.searchParams.has('scan')) {
                newLocationUrl.searchParams.delete('s');
                newLocationUrl.searchParams.delete('scan');
            }

            window.history.pushState(this.state, '', newLocationUrl);
        } catch (e) {
            // TODO: Add proper error handling
        }
    }

    reset() {
        let resetState = Object.assign({}, initialState);
        resetState.url = this.state.url;
        this.setState(resetState);
    }

    onScanFormSubmit(event) {
        let scan_id = event.detail.scan_id;
        let url = event.detail.url;
        let $this = this;

        if (scan_id) {
            $this.setState({
                view: VIEW_SCAN_LOADER,
                scan_id: scan_id
            }, this.checkResult);
        } else if (url) {
            $this.setState({
                url: url
            }, this.startScan)
        }
    }

    startScan() {
        let $this = this;
        window.history.replaceState($this.state, '');

        $this.setState({
            view: VIEW_SCAN_LOADER
        }, () => {
            axios.post(this.props.apiBase + '/api/scan', {
                url: $this.state.url
            }, { withCredentials: true }).then((response) => {
                $this.setState({
                    scan_id: response.data.scan_id
                }, $this.startCheckResult);
            }).catch((error) => {
                document.dispatchEvent(new CustomEvent(EVENT_ERROR, {
                    detail: {
                        error: error.message,
                        errorInfo: error
                    }
                }));
            });
        });
    }

    startCheckResult() {
        if (this.state.check_result_interval) {
            return;
        }

        window.setTimeout(this.checkResult, 5 * 1000);

        let interval = window.setInterval(this.checkResult, 10 * 1000);
        this.setState({
            check_result_interval: interval
        });
    }

    clearCheckResultInterval() {
        if (!this.state.check_result_interval) {
            return;
        }

        window.clearInterval(this.state.check_result_interval);

        this.setState({
            check_result_interval: null,
            check_result_count: 0
        });
    }

    checkResult() {
        let $this = this;

        if ($this.state.check_result_count > 11) {
            document.dispatchEvent(new CustomEvent(EVENT_ERROR, {
                detail: {
                    error: 'Timeout',
                    errorInfo: $this.state
                }
            }));
            $this.clearCheckResultInterval();
            return;
        }

        $this.setState({
            check_result_count: $this.state.check_result_count + 1
        });

        if (!$this.state.scan_id) {
            $this.clearCheckResultInterval();
            return;
        }

        axios.get(`${$this.props.apiBase}/api/result/${this.state.scan_id}`, { withCredentials: true })
            .then((response) => {
            if (!response.data.state || response.data.state !== 'success') {
                $this.startCheckResult();
                return;
            }

            document.dispatchEvent(new CustomEvent(EVENT_RESULT_AVAILABLE, {
                detail: {
                    result: response.data
                }
            }));
        }).catch((error) => {
            document.dispatchEvent(new CustomEvent(EVENT_ERROR, {
                detail: {
                    error: error.message,
                    errorInfo: error
                }
            }));
        });
    }

    onResultAvailable(event) {
        let $this = this;

        $this.setState({
            view: VIEW_SCAN_RESULT,
            url: event.detail.result.url,
            result: event.detail.result,
            scan_id: event.detail.result.scan_id
        }, () => {
            $this.clearCheckResultInterval();
            $this.updateBrowserUrl();
        });
    }

    onDetailsButtonClicked() {
        if (this.state.result.lead_required === true) {
            this.setState({
                show_lead_modal: true
            });
        } else {
            document.dispatchEvent(new CustomEvent(EVENT_LEAD_CONFIRMED));
        }
    }

    onLeadConfirmed() {
        this.onModalClosed();
    }

    onModalClosed() {
        this.setState({
            show_lead_modal: false
        });
    }

    render() {
        return (

            <ErrorBoundary>
                <div aria-label='Google Fonts Scanner' className='font-sans text-gray-base'>
                    {(VIEW_SCAN_FORM === this.state.view) && (
                        <Form
                            url={this.state.url}
                        />
                    )}

                    {(VIEW_SCAN_LOADER === this.state.view) && (
                        <Loader
                            url={this.state.url}
                        />
                    )}

                    {(VIEW_SCAN_RESULT === this.state.view) && (
                        <Result
                            apiBase={this.props.apiBase}
                            url={this.state.url}
                            result={this.state.result}
                            premium={this.props.premium}
                        />
                    )}

                </div>
                {(this.state.show_lead_modal === true) && (
                    <LeadModal
                        apiBase={this.props.apiBase}
                        result={this.state.result}
                    />
                )}
            </ErrorBoundary>
        )
    }
}
